<form #form="ngForm" [formGroup]="editSettingsForm" (ngSubmit)="onSubmited()" class="col-xl-10 col-md-12 col-sm-12 mt-3 mx-auto mt-5 mb-5">

	<div class="row justify-content-end">
		<mat-icon class="ml-auto pointer" matTooltip="Refresh" (click)="onRefresh()" color="primary">refresh</mat-icon>
	</div>

	<mat-label><b>Brew</b></mat-label>
	<br>
	<br>

	<div class="row">
		<mat-form-field class="col-xl col-md-5 col-sm-12">
			<input  matInput placeholder="Brew Check Number" #brew_chk_num  formControlName="brew_chk_num">
			<mat-icon class="pending" matTooltip="Pending" *ngIf="reported && brew_chk_num.value && !hasApplied('brew_chk_num')" matSuffix>schedule</mat-icon>
			<mat-icon class="done" matTooltip="Applied" *ngIf="reported && brew_chk_num.value && hasApplied('brew_chk_num')" matSuffix>done</mat-icon>
			<!-- <mat-icon class="done" matSuffix>cloud_off</mat-icon> -->

		</mat-form-field>

		<mat-form-field class="col-xl col-md-5 col-sm-12">
			<input  matInput placeholder="Brew High" maxlength="100" #brew_chk_hi formControlName="brew_chk_hi">
			<mat-icon class="pending" matTooltip="Pending" *ngIf="reported && brew_chk_hi.value && !hasApplied('brew_chk_hi')" matSuffix>schedule</mat-icon>
			<mat-icon class="done" matTooltip="Applied" *ngIf="reported && brew_chk_hi.value && hasApplied('brew_chk_hi')" matSuffix>done</mat-icon>
		</mat-form-field>

		<mat-form-field class="col-xl col-md-5 col-sm-12">
			<input  matInput placeholder="Brew Low" #brew_chk_lo  formControlName="brew_chk_lo">
			<mat-icon class="pending" matTooltip="Pending" *ngIf="reported && brew_chk_lo.value && !hasApplied('brew_chk_lo')" matSuffix>schedule</mat-icon>
			<mat-icon class="done" matTooltip="Applied" *ngIf="reported && brew_chk_lo.value && hasApplied('brew_chk_lo')" matSuffix>done</mat-icon>
		</mat-form-field>

		<!-- <mat-form-field class="col-xl col-md-5 col-sm-12">
			<input matInput placeholder="Machine Name" maxlength="100" formControlName="machine_name" >
		</mat-form-field> -->

	</div>
	<mat-label><b>Calibration</b></mat-label>
	<br>
	<br>

	<div class="row">
		<mat-form-field class="col-xl-4 col-md-5 col-sm-12">
			<input  matInput placeholder="Coffee Calib Factor" #cof_cab_factor  formControlName="cof_cab_factor">
			<mat-icon class="pending" matTooltip="Pending" *ngIf="reported && cof_cab_factor.value && !hasApplied('cof_cab_factor')" matSuffix>schedule</mat-icon>
			<mat-icon class="done" matTooltip="Applied" *ngIf="reported && cof_cab_factor.value && hasApplied('cof_cab_factor')" matSuffix>done</mat-icon>
		</mat-form-field>

		<!-- <mat-form-field class="col-xl col-md-5 col-sm-12">
			<input matInput placeholder="Machine Name" maxlength="100" formControlName="machine_name" >
		</mat-form-field> -->

	</div>

	<br>
	<div class="text-right mt-3">
		<!-- <button mat-raised-button type="button" (click)="onBack()" class="mat-danger">Back</button> &nbsp; -->
		<button mat-raised-button [disabled]="!editSettingsForm.valid" type="submit" color="primary">Update Info</button>
	</div>
	</form>
